/**
 * Created by dboukezoula on 23/04/2018.
 */
jQuery(document).ready(function () {
    function CheckJobs() {

        var curRegions = $('#regions').val();
        var curSectors = $('#sectors').val();
        //var curCategories = parseInt($('#sectors').val());
        //Get the current select project and make it an integer
        $('#accordion__data span.accordion__filter').each(function () { //Loop through each option
            var arrRegion = $(this).attr('data-region'); //Put the array of projects in a variable
            var arrSector = $(this).attr('data-sector');
            var dataControl = $(this).parent().attr('data-controls');
            if (curRegions == 0 && curSectors == 0){
                $(this).parent().show();
            }
            else if ((curRegions==arrRegion || curRegions == 0) && (curSectors==arrSector || curSectors == 0)) { //If current project ID is in array of projects

                $(this).parent().show(); //Show the option
            }
            else { // Else if current project ID is NOT in array of projects
                $(this).parent().hide(); //hide the option
                $(this).parent().attr( "aria-pressed", "false" );
                $('#'+dataControl).hide();
                $('#'+dataControl).attr( "aria-expanded", "false" );
            }
        });
    }

    CheckJobs(); //Call the function when we run the page (at bottom of page, or within $(document).ready or something similar)
    $('#regions').on('change', function() { //When we change the project, call the function
        CheckJobs();
    });
    $('#sectors').on('change', function() { //When we change the project, call the function
        CheckJobs();
    });

});


// WEBPACK FOOTER //
// ../work/src/js/jobsfair.js